import { render, staticRenderFns } from "./WorksStepSimple.vue?vue&type=template&id=4e544441&"
import script from "./WorksStepSimple.vue?vue&type=script&lang=js&"
export * from "./WorksStepSimple.vue?vue&type=script&lang=js&"
import style0 from "./WorksStepSimple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports